import { Radio } from '@mui/material';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';

interface getRadioColumnParams {
  selectionModel: string[];
}

export function getRadioColumn({ selectionModel }: getRadioColumnParams) {
  const radioColumn: GridColDef = {
    field: '__radio__',
    headerName: '',
    width: 60,
    sortable: false,
    display: 'flex',
    renderCell: (params: GridRenderCellParams<any, number>) => {
      return (
        <Radio
          checked={selectionModel.includes(String(params.id))}
          value={params.id}
        />
      );
    },
  };

  return radioColumn;
}
